export default function PreComLoader(){
    return(
        <div className="loader-box">
            <span className="com-loader">Loading...</span>
        </div>
    )
}